import { render, staticRenderFns } from "./profile-home.vue?vue&type=template&id=f7bd4baa&"
import script from "./profile-home.vue?vue&type=script&lang=js&"
export * from "./profile-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports